import React from "react";

/**
 * Bilder in Markdown-Feldern: Größe und Ausrichtung stehen als Stichworte im Bildtitel,
 * z. B. `![Prüfsiegel](https://… "klein rechts")`. So bleibt der Text reines Markdown
 * (kein HTML, kein XSS), und Anzeigen, die die Stichworte nicht kennen, zeigen das Bild
 * einfach in Standardgröße. Dieselbe Auswertung steht in der Buchungs-App
 * (ko-integrated-2, `views/MarkdownImage/MarkdownImage.tsx`) — Stichworte nur gemeinsam ändern.
 */
export const IMAGE_SIZES = {klein: "120px", mittel: "240px", groß: "480px", voll: "100%"};
export const IMAGE_ALIGNS = ["links", "mitte", "rechts"] as const;

export type ImageSize = keyof typeof IMAGE_SIZES;
export type ImageAlign = (typeof IMAGE_ALIGNS)[number];
export type ImageLayout = {size?: ImageSize; align?: ImageAlign};

export const parseImageLayout = (title?: string | null): ImageLayout => {
    const layout: ImageLayout = {};

    (title || "").split(/\s+/).forEach((word) => {
        if (Object.prototype.hasOwnProperty.call(IMAGE_SIZES, word)) {
            layout.size = word as ImageSize;
        } else if ((IMAGE_ALIGNS as ReadonlyArray<string>).includes(word)) {
            layout.align = word as ImageAlign;
        }
    });

    return layout;
};

/** Stichworte für den Bildtitel; „mitte“ ist der Standard und wird weggelassen. */
export const layoutTitle = ({size, align}: ImageLayout): string => [size, align === "mitte" ? undefined : align].filter(Boolean).join(" ");

export const imageLayoutStyle = ({size, align}: ImageLayout): React.CSSProperties => {
    const style: React.CSSProperties = size ? {width: IMAGE_SIZES[size]} : {};

    // Umflossene Bilder samt seitlichem Abstand nie breiter als der Block (wie in der Buchungs-App).
    if (align === "links") {
        return {...style, float: "left", margin: "0.25em 1em 0.5em 0", maxWidth: "calc(100% - 1em)"};
    }
    if (align === "rechts") {
        return {...style, float: "right", margin: "0.25em 0 0.5em 1em", maxWidth: "calc(100% - 1em)"};
    }

    return style;
};
